module.exports = __webpack_public_path__ + "img/picto_message_astuce.e80c75da.svg";